import React, { memo } from "react";

import Typography from "@material-ui/core/Typography";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";

import { SlimButton } from "components/Button";
import { Column } from "components/Layout";

import {
  getHasTemporaryBusinessWarningsInCurrentSale,
  selectTemporaryBusinessWarningsInCurrentSale,
} from "selectors";

import { useHasTemporaryBusinessesPermission } from "hooks";

export const useHasTemporaryBusinessWarnings = () => {
  const hasTemporaryBusinesses = useHasTemporaryBusinessesPermission();
  const hasWarnings = useSelector(getHasTemporaryBusinessWarningsInCurrentSale);
  return hasTemporaryBusinesses && hasWarnings;
};

// Same surface as the striped warning tables' rows and border.
const Surface = styled(Column)`
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

// A count of the Sale's unresolved temporary Businesses, rather than a row
// each - resolving happens in the Temporary Businesses dialog.
function TemporaryBusinessesToResolveComponent({ onResolve }) {
  const count = useSelector(
    state => selectTemporaryBusinessWarningsInCurrentSale(state).length,
  );

  return (
    <Surface alignCenter padding={3} gridGap={2}>
      <Typography>
        {`${count} temporary ${
          count === 1 ? "business" : "businesses"
        } to resolve`}
      </Typography>
      <SlimButton data-tour="resolve-temporary-businesses" onClick={onResolve}>
        Resolve
      </SlimButton>
    </Surface>
  );
}

export default memo(TemporaryBusinessesToResolveComponent);
